import React, { useState } from "react";

export default function WeatherTemp(props) {
  const [temp, setTemp] = useState("Celsius");

  function displayCelsius(event) {
    event.preventDefault();
    setTemp("Celsius");
  }

  function displayFahrenheit(event) {
    event.preventDefault();
    setTemp("Fahrenheit");
  }

  function Fahrenheit() {
    return (props.Celsius * 9) / 5 + 32;
  }
  if (temp === "Celsius") {
    return (
      <span className="WeatherLinks">
        {Math.round(props.Celsius)}
        <a href="/" onClick={displayFahrenheit}>
          °C |
        </a>
        <a href="/">°F</a>
      </span>
    );
  } else {
    return (
      <span className="WeatherLinks">
        {Math.round(Fahrenheit())}
        <a href="/"> °C </a> |
        <a href="/" onClick={displayCelsius}>
          °F
        </a>
      </span>
    );
  }
}
